import {Injectable, Injector} from '@angular/core';
import {ListService} from '@shared/models/list-service.model';
import {Observable} from 'rxjs/Rx';
import {DossierList} from '../models/dossier-list.model';
import {OperationsFilterModel} from '../models/operations-filter.model';
import {DossierModel, ServerAcceptingData} from '../models/dossier.model';
import {RequestOptions, Response} from '@angular/http';
import {Appointments2Service} from '../../../appointments/services/appointments2.service';
import {Utilities} from '@shared/utilities/utilities.model';

import {WORKING_TYPE_CONFIGURATION, WorkingConfiguration} from '../models/working-configuration.model';
import {EsbContractModel} from '../models/esb-contract-model';
import {ClaimModel} from '../models/claim-model';
import {DossierHistoryListModel} from '../models/dossier-history-list.model';
import {VehicleEquipmentRequestModel} from '../models/vehicle-equipment.model';
import {VehicleAccessoriesRequestModel} from '../models/vehicle-accessories.model';
import {CommodityModel} from '@shared/models/commodity.model';
import {FileModel} from '../models/enums.model';
import {AttachmentsService} from './attachments.service';
import {of, Subject, Subscription, throwError} from 'rxjs';
import {MechanicWorkingItemsRequestModel} from '../models/mechanic-working-items.model';
import {AdministrationWorkingItemsRequestModel} from '../models/administration-working-items.model';
import {CarbodyWorkingItemsRequestModel} from '../models/carbody-working-items.model';
import {UploadFileService} from '@shared/service/upload-file.service';
import {FileManagerPollingService} from '@shared/service/file-manager-polling.service';
import {catchError, map, tap} from 'rxjs/operators';
import {SelectCommoditiesService} from '@shared/service/select-commodities.service';
import {InnerMessageAuthorityMessageCode} from './inner-message-authority-utilities';
import {CommonMessageCode, MessageComponentType, MessageDetail, MessageType} from '@shared/service/message-manager/message.model';
import {MessageManagerUtilities} from '@shared/service/message-manager/message-manager-utilities';
import {AuthorityBaseService} from './authority-base.service';
import {ExportDossieDialogOutput} from '../components/au-export-dossie-csv/au-export-dossie-csv.component';
import {ClaimsPracticeModel} from '../../../claims/claims-practices/models/claims-practice.model';
import {PracticeModel} from '../models/practice-model';
import {UserV3Model} from '@shared/models/user-v-3.model';
import {PermissionService} from '@shared/service/permission.service';
import {AldDossierInnerNoteListResponse, AldDossierInnerNoteModel} from '../models/ald-dossier-inner-note.model';
import {QuotationsSyncErrorModel} from '../models/quotations-sync-error.model';


const jsonClaimsFile1: any = require('../../authority-sp/services/mock/jsonClaims1.json');
const jsonPracticesFile: any = require('../../authority-sp/services/mock/jsonPractices.json');
const jsonPracticesListFile: any = require('../../authority-sp/services/mock/jsonWorkingsPractice.json');

@Injectable()
export class 	DossiersConsultationService extends AuthorityBaseService implements ListService {

	dossierRefresher: Subject<void> = new Subject<void>(); // Serve a refreshare i dati del dossier
	downloadPaperSignaturePollingSubscription: Subscription;

	hasLoadedQuotation: Subject<{ working_id: string, loaded: boolean }> = new Subject<{ working_id: string; loaded: boolean }>();

	constructor(protected injector: Injector,
				//private commoditiesService: CommoditiesService,
				private selectCommoditiesService: SelectCommoditiesService,
				public appointmentService: Appointments2Service,
				public permissionsService: PermissionService,
				private attachmentsService: AttachmentsService,
				private uploadFileService: UploadFileService,
				private fileManagerPollingService: FileManagerPollingService) {
		super(injector);
	}

	getDossierRefresher(): Subject<void> {
		return this.dossierRefresher;
	}

	getList(filter: OperationsFilterModel, params?: any): Observable<DossierList> {
		let url: string = this.environment.AUTHORITY + '/dossiers/consultation';
		if (filter) {
			url = url + filter.getFilterUrl();
		}
		const commodities: string[] = this.selectCommoditiesService.getIDCommodities();
		const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(commodities);
		return new Observable<DossierList>(
			observer => {
				this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
					response => {
						if (response.status === 200) {
							try {
								observer.next(new DossierList(response.json()));
							} catch (error) {
								observer.error(error);
							}
						} else {
							observer.next(null);
						}
					},
					error => {
						observer.error(error);
					}
				);
			});
	}

	getDossierById(dossierId: string, onSuccess: (dossierModel: DossierModel) => void, onFailure: (errorMessage: MessageDetail) => void): void {
		const url: string = this.environment.AUTHORITY + '/dossiers/' + dossierId;
		const commodities: CommodityModel[] = this.permissionsService.getCommoditiesFromItemMenuID(UserV3Model.AUTHORITY_ITEM_MENU_ID);
		const arrayCommodities: string[] = [];
		commodities.forEach((commodity) => {
			arrayCommodities.push(commodity.id);
		});
		const options: any = Utilities.setOptionsWithNemoCommodityID(arrayCommodities);
		//const options: RequestOptions = new RequestOptions();
		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						onSuccess(new DossierModel(response.json()));
					} catch (error) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure({
						type: MessageType.TYPE_ERROR,
						code: CommonMessageCode.GENERIC_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getServerDossierAcceptance(dossierId: string): Observable<ServerAcceptingData> {
		return this.httpAuthService
			.get(`${this.environment.AUTHORITY}/dossiers/${dossierId}`, this.redirectUrl, new RequestOptions())
			.pipe(map(response => (response.status === 200 && response && response.json() && response.json().accepting_data) || null));
	}

	updateDossierAcceptance(dossierId: string, body: AcceptingDataRequestBody, commodities: any,
							onSuccess: (response: Response) => void, onFailure: (message: MessageDetail) => void): void {
		const url: string = this.environment.AUTHORITY + '/dossiers/' + dossierId + '/accepting_data';
		const options: RequestOptions = Utilities.setOptionsWithNemoCommodityID(commodities);
		this.httpAuthService.patch(url, body, this.environment.ROOT_REDIRECT, options).subscribe(
			response => response.ok ? onSuccess(response) :
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response)),
			error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}

	getWorkingConfiguration(actives_only: boolean, dossier_id: string, onSuccess: (workingConfiguration: WorkingConfiguration, message: MessageDetail) => void,
							onFailure: (message: MessageDetail) => void): void {
		let url: string = this.environment.AUTHORITY + '/dossiers/' + dossier_id + '/workings/configuration';
		const type: any = {actives_only: actives_only};
		url = url + Utilities.getQuery(type);
		const options: RequestOptions = new RequestOptions();
		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						let commoditiesCheck: any;
						WORKING_TYPE_CONFIGURATION.forEach(workingType => commoditiesCheck = response.json().working_type_map[workingType].commodities);
						if (actives_only && !commoditiesCheck) {
							onFailure({
								code: InnerMessageAuthorityMessageCode.GATEWAY_1002,
								type: MessageType.TYPE_WARNING,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
							return;
						}
						onSuccess(new WorkingConfiguration(response.json()), MessageManagerUtilities.getMessageDetailsFromResponse(response));
					} catch (error) {
						onFailure({
							code: CommonMessageCode.GENERIC_ERROR,
							type: MessageType.TYPE_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure({
						code: CommonMessageCode.GENERIC_ERROR,
						type: MessageType.TYPE_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			});
	}

	searchContract(body: any, commodity: string, onSuccess: (response: any) => void, onFailure: (message: MessageDetail) => void): void {
		let url: string = this.environment.AUTHORITY + '/contracts';
		url = url + Utilities.getQuery(body);
		const options: any = Utilities.setOptionsWithNemoCommodityID([commodity]);

		this.httpAuthService.get(url, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						const responseParsed: any = response.json();
						const esbContractModels: EsbContractModel[] = [];

						if (responseParsed.lenght) {
							responseParsed.forEach(el => {
								esbContractModels.push(new EsbContractModel(el));
							});
						} else {
							esbContractModels.push(new EsbContractModel(responseParsed));
						}

						onSuccess(esbContractModels);
					} catch (error) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
			}
		);
	}

	getClaimsByPlateAndChassis(plate: string, chassis: string, page?: number, pageSize?: number): Observable<{ claims: ClaimModel[], stats: any, message: MessageDetail }> {
		const body: any = {
			plate,
			...chassis && {chassis},
			...page && pageSize && {page, page_size: pageSize}
		};
		const url: string = `${this.environment.AUTHORITY}/claims/${plate}${Utilities.getQuery(body)}`;
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).pipe(map(response => {
			if (response.ok) {
				try {
					const res: { items: any[], stats: any } = response.json();
					const claims: ClaimModel[] = res.items.map(claim => new ClaimModel(claim));
					return {
						claims,
						message: MessageManagerUtilities.getMessageDetailsFromResponse(response),
						stats: res.stats
					};
				} catch (error) {
					throw MessageManagerUtilities.getMessageDetailsFromResponse(error);
				}
			} else {
				throw MessageManagerUtilities.getMessageDetailsFromResponse(new Error());
			}
		}), catchError(error => {
			throw MessageManagerUtilities.getMessageDetailsFromResponse(error);
		}));
	}

	getClaimsByPlate(
		plate: string,
		chassis: string,
		onSuccess: (claims: ClaimModel[], message: MessageDetail, itemCount?: number, pageCount?: number) => void,
		onFailure: (message: MessageDetail) => void, page?: number, pageSize?: number,
	): void {
		if (this.environment.environment === 'selocal') {
			const jsonMock: any = jsonClaimsFile1;
			try {
				const claims: ClaimModel[] = [];
				jsonMock.items.forEach(claim => claims.push(claim));
				onSuccess(claims, MessageManagerUtilities.getMessageDetailsFromResponse(jsonMock));
			} catch (error) {
				onFailure({
					type: MessageType.TYPE_ERROR,
					code: CommonMessageCode.GENERIC_ERROR,
					componentType: MessageComponentType.FLASH_MESSAGE
				});
			}
		} else {
			let url: string = this.environment.AUTHORITY + '/claims';
			const body: any = {
				plate: plate,
				chassis: chassis
			};
			url = url + Utilities.getQuery(body);
			if (page && pageSize) {
				url += '&page=' + page + '&page_size=' + pageSize;
			}
			this.httpAuthService.get(url, this.redirectUrl).subscribe(
				response => {
					if (response.status === 200) {
						try {
							const claims: ClaimModel[] = [];
							let itemCount: number = 0;
							let pageCount: number = 0;
							response.json().items.forEach(claim => claims.push(new ClaimModel(claim)));
							itemCount = response.json().stats.item_count;
							pageCount = response.json().stats.page_count;
							if (itemCount && pageCount) {
								onSuccess(claims, MessageManagerUtilities.getMessageDetailsFromResponse(response), itemCount, pageCount);
							} else {
								onSuccess(claims, MessageManagerUtilities.getMessageDetailsFromResponse(response));
							}
						} catch (error) {
							onFailure({
								type: MessageType.TYPE_ERROR,
								code: CommonMessageCode.GENERIC_ERROR,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						}
					} else {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				},
				error => {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				});
		}
	}

	getPracticesByPlate(plate: string, onSuccess: (practice: ClaimsPracticeModel[], message: MessageDetail) => void, onFailure: (message: MessageDetail) => void): void {
		this.environment = this.appConfig.Environment;
		if (this.environment.environment === 'local') {
			const jsonMock: any = jsonPracticesFile;
			try {
				const practices: ClaimsPracticeModel[] = [];
				jsonMock.items.forEach(practice => practices.push(practice));
				onSuccess(practices, MessageManagerUtilities.getMessageDetailsFromResponse(jsonMock));
			} catch (error) {
				onFailure({
					type: MessageType.TYPE_ERROR,
					code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
					componentType: MessageComponentType.FLASH_MESSAGE
				});
			}
		} else {
			const url: string = this.environment.AUTHORITY + '/claims/' + plate;
			this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).subscribe(
				response => {
					if (response.ok) {
						try {
							const practices: ClaimsPracticeModel[] = [];
							response.json().items.forEach(practice => practices.push(new ClaimsPracticeModel(practice)));
							onSuccess(practices, MessageManagerUtilities.getMessageDetailsFromResponse(response));
						} catch (error) {
							onFailure({
								type: MessageType.TYPE_ERROR,
								code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						}
					} else {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: InnerMessageAuthorityMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				},
				error => {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
				});
		}
	}

	createDossier(
		requestBody: CreateDossierRequestBody,
		commodity: string,
		onSuccess: (dossierId: string, dossierNumberPrefix: string, message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		const url: string = this.environment.AUTHORITY + '/dossiers';
		const options: any = Utilities.setOptionsWithNemoCommodityID([commodity]);
		this.httpAuthService.post(url, requestBody, this.redirectUrl, options).subscribe(
			response => {
				if (response.ok) {
					try {
						const dossierId: string = response.json().id;
						const dossierNumberPrefix: string = response.json().label;
						if (!Utilities.isVoid(dossierId)) {
							this.messageManagerService.deleteAll();
							onSuccess(dossierId, dossierNumberPrefix, {
								type: MessageType.TYPE_SUCCESS,
								code: InnerMessageAuthorityMessageCode.AUTHORITY_OPERATION_SAVED,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						} else {
							this.messageManagerService.deleteAll();
							onFailure({
								type: MessageType.TYPE_SUCCESS,
								code: InnerMessageAuthorityMessageCode.AUTHORITY_DOSSIER_NOT_SAVED,
								componentType: MessageComponentType.FLASH_MESSAGE
							});
						}
					} catch (e) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
				}
			},
			error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}

	updateDossier(
		body: DossierModel,
		commodity: string[],
		onSuccess: (dossier: DossierModel, message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		const url: string = this.environment.AUTHORITY + '/dossiers/' + body.id;
		const options: any = Utilities.setOptionsWithNemoCommodityID(commodity);
		this.httpAuthService.put(url, body, this.redirectUrl, options).subscribe(
			response => {
				if (response.status === 200) {
					try {
						onSuccess(new DossierModel(response.json()), MessageManagerUtilities.getMessageDetailsFromResponse(response));
					} catch (e) {
						onFailure({
							type: MessageType.TYPE_ERROR,
							code: CommonMessageCode.GENERIC_ERROR,
							componentType: MessageComponentType.FLASH_MESSAGE
						});
					}
				} else {
					onFailure({
						type: MessageType.TYPE_ERROR,
						code: CommonMessageCode.GENERIC_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			},
			error => onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error))
		);
	}

	updatePriority(dossierId: string, priority: string): Observable<Response> {
		const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/priority`;
		const requestBody: DossierRequestBody = {
			priority: priority,
		};
		return this.httpAuthService.patch(url, requestBody, this.redirectUrl);
	}

	getContractDossiersHistory(
		plate: string,
		page: number,
		pageSize: number,
		onSuccess: (dossierList: DossierHistoryListModel) => void,
		onFailure?: (message: MessageDetail) => void
	): void {
		const url: string = `${this.environment.AUTHORITY}/dossiers/history/${plate}?page=${page}&page_size=${pageSize}`;
		this.httpAuthService.get(url, this.redirectUrl).subscribe((response: any) => {
			if (response.ok) {
				try {
					const responseBody: any = JSON.parse(response._body);
					onSuccess(new DossierHistoryListModel(responseBody));
				} catch (e) {
					onFailure({
						type: MessageType.TYPE_ERROR,
						code: CommonMessageCode.GENERIC_ERROR,
						componentType: MessageComponentType.FLASH_MESSAGE
					});
				}
			} else {
				onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(response));
			}
		}, (error) => {
			onFailure(MessageManagerUtilities.getMessageDetailsFromResponse(error));
		});
	}

	addAttachment(
		dossierId: string,
		commodities: CommodityModel[],
		file: FileModel,
		additionalRequestBody: any,
		onSuccess: (message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/attachments`;
		const params: { key: string, value: string }[] = [{
			key: 'blob_type',
			value: file.blob_type.toUpperCase()
		}, {key: 'thumbnail', value: 'true'}];
		this.attachmentsService.addAttachment(url, commodities, file, additionalRequestBody, onSuccess, onFailure, params);
	}

	addCloseAttachment(
		dossierId: string,
		commodities: CommodityModel[],
		file: FileModel,
		additionalRequestBody: any,
		onSuccess: (message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/close`;
		this.attachmentsService.addCloseAttachment(url, commodities, file, additionalRequestBody, onSuccess, onFailure, []);
	}

	removeAttachments(
		dossierId: string,
		commodities: CommodityModel[],
		attachmentIds: string[],
		onSuccess: (message: MessageDetail) => void,
		onFailure: (message: MessageDetail) => void
	): void {
		const url: string = `${this.environment.AUTHORITY}/dossiers/${dossierId}/attachments`;
		this.attachmentsService.removeAttachments(url, commodities, attachmentIds, onSuccess, onFailure, [{
			key: 'ids',
			value: attachmentIds.toString()
		}]);
	}

	downloadPaperSignature(data: any, id: string, type: 'acceptance' | 'redelivery', isToOtherCommodity: boolean = false): Observable<[Response, FileModel]> {
		const url: string = `${this.environment.AUTHORITY}/dossiers/${id}/${type}_document${isToOtherCommodity ? '?to_other_center=true' : ''}`;
		return new Observable<[Response, FileModel]>(subscriber => {
			this.httpAuthService.post(url, data, this.redirectUrl).subscribe((res: Response) => {
				const obj: FileModel = res.json();
				if (res.ok && obj.uuid) {
					const file: FileModel = obj;
					const fileManagerId: string = file.uuid;
					this.fileManagerPollingService.settingPolling(fileManagerId, 6);
					const stopPolling: Function = () => {
						this.fileManagerPollingService.stopPolling();
						this.downloadPaperSignaturePollingSubscription.unsubscribe();
					};
					this.downloadPaperSignaturePollingSubscription = this.fileManagerPollingService.pollingObservable.subscribe(async (resp: any) => {
						if (resp && resp.id && resp.file_name) {
							stopPolling();
							this.uploadFileService.downloadAttachedFile(resp.id).subscribe((value: Response) => {
								subscriber.next([value, file]);
							}, error => subscriber.error(error));
						}
					}, error => {
						stopPolling();
						subscriber.error(new Error(`Errore durante il download in polling del documento ${fileManagerId}`));
					});
				} else {
					subscriber.error(new Error('Errore durante il download del documento'));
				}
			}, error => {
				subscriber.error(error);
			});
		});
	}

	getInterventionFileCsv(filter: ExportDossieDialogOutput): Observable<Response> {
		let url: string = this.environment.AUTHORITY + '/dossiers' + '/woe_document';
		url = url + Utilities.getQuery(filter);
		return this.httpAuthService.get(url, this.redirectUrl);
	}

	getPracticesListByPlate(plate: string, chassis: string, page?: number, pageSize?: number, types: string[] = [PracticeType.STAMP, PracticeType.TO_RE_REGISTER]): Observable<{ practices: PracticeModel[], stats: any, message: MessageDetail }> {
		const body: any = {
			...plate && {plate},
			...chassis && {chassis},
			...page && pageSize && {page, page_size: pageSize},
			...types && {types}
		};
		const url: string = `${this.environment.AUTHORITY}/carpractice/${plate}${Utilities.getQuery(body)}`;
		return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT).pipe(map(response => {
			if (response.ok) {
				try {
					const res: { items: any[], stats: any } = response.json();
					const practices: PracticeModel[] = res.items.map(practice => new PracticeModel(practice));
					return {
						practices,
						message: MessageManagerUtilities.getMessageDetailsFromResponse(response),
						stats: res.stats
					};
				} catch (error) {
					throw MessageManagerUtilities.getMessageDetailsFromResponse(error);
				}
			} else {
				throw MessageManagerUtilities.getMessageDetailsFromResponse(new Error());
			}
		}), catchError(error => {
			throw MessageManagerUtilities.getMessageDetailsFromResponse(error);
		}));

	}

	closeDossierById(dossier_id: string): Observable<Response> {
		return this.httpAuthService.patch(`${this.environment.AUTHORITY}/dossiers/${dossier_id}/delivering`, null, this.redirectUrl).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	deleteDossier(dossier_id: string): Observable<Response> {
		return this.httpAuthService.delete(
			`${this.environment.AUTHORITY}/dossiers/${dossier_id}`,
			this.redirectUrl
		).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	getDossierNotesById(dossier_id: string): Observable<AldDossierInnerNoteListResponse> {
		return this.httpAuthService.get(
			`${this.environment.AUTHORITY}/dossiers/${dossier_id}/notes`,
			this.redirectUrl
		).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json())
		);
	}

	saveDossierNote(dossier_id: string, note: AldDossierInnerNoteModel): Observable<{ id: string }> {
		return this.httpAuthService.post(
			`${this.environment.AUTHORITY}/dossiers/${dossier_id}`,
			note,
			this.redirectUrl
		).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	updateDossierNote(dossier_id: string, note: AldDossierInnerNoteModel): Observable<any> {
		return this.httpAuthService.put(
			`${this.environment.AUTHORITY}/dossiers/${dossier_id}/notes/${note.id}`,
			note,
			this.redirectUrl
		).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	deleteDossierNote(dossier_id: string, note: AldDossierInnerNoteModel): Observable<any> {
		return this.httpAuthService.delete(
			`${this.environment.AUTHORITY}/dossiers/${dossier_id}/notes/${note.id}`,
			this.redirectUrl
		).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}),
			map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}

	getQuotationsSyncErrorsByDossierID(dossier_id: string): Observable<QuotationsSyncErrorModel> {
		return this.httpAuthService.post(
			`${this.environment.AUTHORITY}/dossiers/${dossier_id}/quotations_refresh`,
			null,
			this.redirectUrl
		).pipe(
			tap(response => {
				if (!response.ok) {
					throw response;
				}
			}), map(response => response.json()),
			catchError(err => {
				this.handleErrorResponse(err);
				return throwError(err);
			})
		);
	}
}

interface DossierRequestBody {
	priority: string;
}

export interface CreateDossierRequestBody {
	contract_id: string;
	customer_id: string;
	driver_id: string;
	plate: string;
	appointment_id?: string;
}

export interface AcceptingDataRequestBody {
	accepting_km: string;
	car_shape: any;
	ddt_number: string;
	email: string;
	expected_delivery_date: string;
	first_name: string;
	fuel_level: string;
	last_name: string;
	phone: string;
	rescue_company: string;
	truck_plate: string;
	carbody_note: string;
	saddlery_note: string;
	carbody_working_items: CarbodyWorkingItemsRequestModel;
	administration_working_items: AdministrationWorkingItemsRequestModel;
	mechanic_working_items: MechanicWorkingItemsRequestModel;
	vehicle_equipment: VehicleEquipmentRequestModel;
	vehicle_accessories: VehicleAccessoriesRequestModel;
	tires_wear_level: number;
	fiscal_code: string;
	replacement_vehicle_plate: string;
}

export interface HistoryQueryParams {
	plate: string;
	dossierNumberPrefix: string;
	dossierId: string;
}

export enum PracticeType {
	TO_RE_REGISTER = 'TO_RE_REGISTER',
	STAMP = 'STAMP'
}
